module.exports = __webpack_public_path__ + "img/car-cover-main.c551149.png";